import React from 'react';
import { Nav } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import colors from '../colors';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';

const HeaderSticky = styled.div`
  background: ${colors.main};
  position: fixed;
  top: 0;
  left: 0;
  height: 53px;
  width: 100%;
  z-index: 100;
`;

const HeaderWrap = styled.div`
  padding-bottom: 53px;

  @media screen and (max-width: 1024px) {
    ${HeaderSticky} {
      position: relative;
    }
    padding-bottom: 0;
  }
`;
const Content = styled.div`
  max-width: 1280px;
  min-width: 1024px;
  margin: auto;
  padding: 8px 28px;
`;
const StyledLink = styled(NavLink)<{ isActive?: boolean }>`
  color: ${colors.white};
  text-transform: uppercase;
  font-size: 14px;
  padding: 8px;
  text-decoration: none;
  &:active,
  &:hover {
    color: ${colors.second};
  }
  ${(props) =>
    props.isActive &&
    css`
      background: ${colors.hover};
      border-radius: 4px;
    `}
`;

const SettingsLink = styled.span<{ isActive?: boolean }>`
  color: ${colors.white};
  text-transform: uppercase;
  font-size: 14px;
  padding: 8px;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  &:hover {
    color: ${colors.second};
  }
  ${(props) => {
    return (
      props.isActive &&
      css`
        background: ${colors.hover};
        border-radius: 4px;
      `
    );
  }}
`;

const buttons = [
  { path: '/answers', label: 'Ответы на отзывы' },
  { path: '/questions', label: 'Вопросы' },
  // { path: '/agent', label: 'Агент' },
  // { path: "/sales", label: "Продажи" },
  { path: '/remnants', label: 'Остатки', match: '/remnants' },
  { path: '/supplies', label: 'Поставки' },
  { path: '/wb-slots', label: 'Слоты WB' },
  { path: '/price_loader', label: 'Цены' },
  { path: '/price_monitoring', label: 'Мониторинг цен' },
  { path: '/settings', label: 'Настройки', isDropdown: true },
];

const settingsMenuItems = [
  {
    key: 'answer_template',
    label: 'Шаблоны ответов',
    path: '/settings/answer_template',
  },
  {
    key: 'product_categories',
    label: 'Категории товаров',
    path: '/settings/product_categories',
  },
  { key: 'goods', label: 'Товары', path: '/settings/goods' },
  {
    key: 'auth_marketplace',
    label: 'Авторизация в МП',
    path: '/settings/auth_marketplace',
  },
  { key: 'logs', label: 'ЛОГИ', path: '/settings/logs' },
  { key: 'features', label: 'Фича-флаги', path: '/settings/features' },
  { key: 'classifier', label: 'Классификатор', path: '/settings/classifier' },
  { key: 'delay_jobs', label: 'Запуск задач', path: '/settings/delay_jobs' },
  {
    key: 'mp_sync_watermarks',
    label: 'MP Watermarks',
    path: '/settings/mp_sync_watermarks',
  },
  { key: 'brands', label: 'Бренды', path: '/settings/brands' },
  { key: 'tags', label: 'Теги', path: '/settings/tags' },
  { key: 'warehouses', label: 'Склады', path: '/settings/warehouses' },
  { key: 'vnc', label: 'VNC', path: '/settings/vnc' },
  { key: 'notifications', label: 'Уведомления', path: '/settings/notifications' },
];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const settingsMenuItems_antd = settingsMenuItems.map((item) => ({
    key: item.key,
    label: item.label,
    onClick: () => navigate(item.path),
  }));

  return (
    <HeaderWrap>
      <HeaderSticky>
        <Content>
          <Nav>
            {buttons.map((el) => {
              if (el.isDropdown) {
                return (
                  <Dropdown
                    key={el.path}
                    menu={{ items: settingsMenuItems_antd }}
                    trigger={['click', 'hover']}
                    placement="bottomLeft"
                  >
                    <SettingsLink
                      isActive={location.pathname.indexOf(el.path) === 0}
                    >
                      {el.label}
                    </SettingsLink>
                  </Dropdown>
                );
              }
              return (
                <StyledLink
                  key={el.path}
                  to={el.path}
                  isActive={
                    location.pathname.indexOf(el.match || el.path) === 0
                  }
                >
                  {el.label}
                </StyledLink>
              );
            })}
          </Nav>
        </Content>
      </HeaderSticky>
    </HeaderWrap>
  );
};

export default Header;
